import { Outlet } from 'react-router-dom';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export default function Auth() {
  return (
    <>
      <CC.Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={CC.useColorModeValue('gray.50', 'gray.800')}
      >
        <Outlet />
      </CC.Flex>
    </>
  );
}
